/* Show a simple confirm prompt. Resolve on accept. Reject on cancel. */
export const justConfirm = async (text: string) => {
  // TODO: Replace this with a on-site modal system once implemented
  // eslint-disable-next-line
  const response = confirm(text);
  if (!response) {
      throw new Error("Declined " + text);
  }  
};